import React from 'react';
import logo from "./assets/new-logo.png";
import Footer from "./components/Footer";
import "./App.css";

const TermsOfService = () => {
  return (
    <div style={{ backgroundColor: "black", minHeight: "100vh", paddingBottom: "40px" }}>
      <div className="img-con-header">
        <a href="/home">
          <img
            className="imgLogo"
            style={{ margin: "2px auto 0px auto" }}
            src={logo}
            width="10%"
            alt="logo"
          />
        </a>
      </div>
      <div style={{ color: "white", width: "80%", maxWidth: "1000px", margin: "20px auto" }}>
        <h1 className="font-eagle-bold" style={{ fontSize: '36px', marginBottom: '30px' }}>Terms of Service</h1>

        <p className="font-semibold">
          Welcome to Vibe Stream by GOGOPIX Inc. By accessing or using our service, you agree to be bound by these Terms of Service.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>1. Acceptance of Terms</h2>
        <p className="font-semibold">
          By creating an account or using Vibe Stream, you agree to these terms and conditions. If you do not agree, please do not use our service.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>2. Service Description</h2>
        <p className="font-semibold">
          Vibe Stream provides music video streaming services with various subscription options including Basic Pass (free) and Party Pass (paid subscription).
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>3. User Accounts</h2>
        <p className="font-semibold">
          You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>4. Subscription and Billing</h2>
        <p className="font-semibold">
          Party Pass is a monthly subscription service billed at $4.99/month. Subscriptions automatically renew unless cancelled. You may cancel at any time through your Stripe subscription management portal.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>5. Content License</h2>
        <p className="font-semibold">
          All music videos on Vibe Stream are licensed content. Unauthorized downloading, distribution, or reproduction of content is strictly prohibited.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>6. Prohibited Conduct</h2>
        <p className="font-semibold">
          You agree not to misuse the service, attempt to gain unauthorized access, or use the service for any illegal purposes.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>7. Limitation of Liability</h2>
        <p className="font-semibold">
          GOGOPIX Inc. is not liable for any indirect, incidental, or consequential damages arising from your use of the service.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>8. Changes to Terms</h2>
        <p className="font-semibold">
          We reserve the right to modify these terms at any time. Continued use of the service constitutes acceptance of modified terms.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>9. Contact</h2>
        <p className="font-semibold">
          For questions about these Terms of Service, please contact us at support@vibe-stream.tv
        </p>

        <p className="font-semibold" style={{ marginTop: '40px', fontSize: '14px', color: '#999' }}>
          Last Updated: February 11, 2026
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfService;
